module.exports = __webpack_public_path__ + "img/middle_2.81de4c82.png";